export default "__VITE_ASSET__CbIM5uFW__"